<template>
  <div class="area_index">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="area_index_main">
        <div class="area_index_main_div_div">
          <div class="area_index_main_divs">
            <div class="area_index_main_divs_divA">
              <div>{{ guojianame }}代理IP</div>
              <div>9,077,144<i>个</i></div>
              <div class="div_text5">
                奇迹ip为您提供高质量{{
                  guojianame
                }}代理IP，使用住宅代理或数据中心代理，稳定拓展全球业务
              </div>
              <div>
                <div class="butt_divarea" @click="openWeChatChat()">免费试用{{ guojianame }}代理</div>
              </div>
            </div>
            <div class="area_index_main_divs_divB">
              <img
                src="http://apiupss.ppfly.top/images/area_info_banner.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="area_index_main_div_div">
          <div class="area_index_main_divsB">
            <div class="area_index_H1">为什么选择奇迹ip代理</div>
            <div>
              <div class="area_index_body">
                <div>
                  <img
                    src="http://apiupss.ppfly.top/images/reason_img1.svg"
                    alt=""
                  />
                  <div class="area_index_name">精准定位</div>
                  <div class="area_index_text">
                    根据国家、城市和运营商选择IP，定位更精准
                  </div>
                </div>
                <div>
                  <img
                    src="http://apiupss.ppfly.top/images/reason_img2.svg"
                    alt=""
                  />
                  <div class="area_index_name">易于集成</div>
                  <div class="area_index_text">
                    轻松与指纹浏览器等第三方软件集成使用
                  </div>
                </div>
                <div>
                  <img
                    src="http://apiupss.ppfly.top/images/reason_img3.svg"
                    alt=""
                  />
                  <div class="area_index_name">安全可靠</div>
                  <div class="area_index_text">
                    99.9%正常运行时间，专业团队实时监控系统运行状态
                  </div>
                </div>
                <div>
                  <img
                    src="http://apiupss.ppfly.top/images/reason_img4.svg"
                    alt=""
                  />
                  <div class="area_index_name">实时支持</div>
                  <div class="area_index_text">
                    7*24小时提供帮助，实时为您解决难题
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="area_index_main_div_div">
          <div class="area_index_main_divsB">
            <div class="area_index_H1">免费IP代理列表</div>
            <div class="div_area_index_bodyB">
              <div class="area_index_bodyB">
                <el-table
                  :data="tableData"
                  style="width: 100%; margin-left: 100px"
                >
                  <el-table-column
                    prop="ip_address"
                    label="IP地址"
                    width="290"
                  ></el-table-column>
                  <el-table-column
                    prop="nation"
                    label="国家"
                    width="290"
                  ></el-table-column>
                  <el-table-column
                    prop="response_speed"
                    label="响应速度"
                    width="290"
                  ></el-table-column>
                  <el-table-column
                    prop="agency_agreement"
                    label="代理协议"
                    width="290"
                  ></el-table-column>
                  <el-table-column
                    prop="type"
                    label="IP类型"
                    width="290"
                  ></el-table-column>
                </el-table>

                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  :total="totalData"
                  layout="total, prev, pager, next, jumper"
                ></el-pagination>
                <div class="table_butt">注册使用免费IP</div>
              </div>
            </div>
          </div>
        </div>

        <div class="area_index_main_div_div">
          <div class="area_index_main_divs with1500">
            <div class="area_index_main_divs_divA DB">
              <div>{{ guojianame }}住宅代理</div>
              <div></div>
              <div class="div_text6">
                使用{{
                  guojianame
                }}真实的家庭住宅IP，高度匿名，保护您的隐私安全。奇迹ip为您提供动态住宅IP、独享静态住宅IP、动态长效ISP等多种住宅代理类型，根据业务需求灵活选择
              </div>
              <div>
                <div class="butt_divB">开始免费测试</div>
              </div>
            </div>
            <div class="area_index_main_divs_divD">
              <img
                src="http://apiupss.ppfly.top/images/li_img1.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="area_index_main_div_divB">
          <div class="area_index_main_divs with1500 top200">
            <div class="area_index_main_divs_divE">
              <img
                src="http://apiupss.ppfly.top/images/li_img2.svg"
                alt=""
              />
            </div>
            <div class="area_index_main_divs_divA DBE">
              <div>数据中心代理</div>
              <div></div>
              <div class="div_text6">
                通过部署多个{{
                  guojianame
                }}数据中心代理服务器，保障高性能同时具有更高性价比，奇迹ip为您提供动态数据中心和独享数据中心两种代理类型，广泛应用于品牌保护、市场调查等业务场景
              </div>
              <div>
                <div class="butt_divB">开始免费测试</div>
              </div>
            </div>
          </div>
        </div>

        <div class="div_3">
          <div class="div_3_div">
            <div class="H2">多种代理类型，满足业务需求</div>
          </div>

          <div class="div_4">
            <div class="div_div_5">
              <div class="div_5">
                <div class="div_5_div">
                  <img
                    src="http://apiupss.ppfly.top/images/pck_card1.svg"
                    alt=""
                  />
                  <div class="div_5_div_H">动态住宅代理</div>
                  <div class="div_5_div_text">真实匿名的家庭住宅IP</div>
                  <div class="div_5_div_butts">免费测试</div>
                </div>
                <div>
                  <div class="div_5_div_li"><li>220+国家地区可选</li></div>
                  <div class="div_5_div_li"><li>无限并发会话</li></div>
                  <div class="div_5_div_li"><li>指定国家/城市/运营商</li></div>
                  <div class="div_5_div_li"><li>1-120min IP切换时效</li></div>
                </div>
              </div>

              <div class="div_5">
                <div class="div_5_div">
                  <img
                    src="http://apiupss.ppfly.top/images/pck_card2.svg"
                    alt=""
                  />
                  <div class="div_5_div_H">静态住宅代理</div>
                  <div class="div_5_div_text">长效独享的真人住宅ISP</div>
                  <div class="div_5_div_butts">免费测试</div>
                </div>
                <div>
                  <div class="div_5_div_li"><li>100+国家地区可选</li></div>
                  <div class="div_5_div_li"><li>真实家庭ISP属性</li></div>
                  <div class="div_5_div_li"><li>不限使用流量</li></div>
                  <div class="div_5_div_li"><li>独享带宽配速</li></div>
                </div>
              </div>

              <div class="div_5">
                <div class="div_5_div">
                  <img
                    src="http://apiupss.ppfly.top/images/pck_card3.svg"
                    alt=""
                  />
                  <div class="div_5_div_H">数据中心代理</div>
                  <div class="div_5_div_text">独享&动态数据中心IP</div>
                  <div class="div_5_div_butts">免费测试</div>
                </div>
                <div>
                  <div class="div_5_div_li"><li>300万+代理池</li></div>
                  <div class="div_5_div_li"><li>无限并发会话</li></div>
                  <div class="div_5_div_li"><li>优选全球数据中心</li></div>
                  <div class="div_5_div_li"><li>HTTP(S)/Socks5协议</li></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="div_8">
          <div class="div_8_div">
            <div class="H2">最新资讯</div>
            <div class="div_div_8_divs">
              <div class="div_8_divs">
                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">设置修改电脑代理IP地址的方法</div>
                    <div class="div_8_divs_text">2021-03-29 09:42:34</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">在线代理有哪些？</div>
                    <div class="div_8_divs_text">2021-03-29 09:35:35</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">
                      代理服务器与无线路由器有什么关系
                    </div>
                    <div class="div_8_divs_text">2021-03-29 09:07:38</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">
                      使用代理服务器必须要注意的细节
                    </div>
                    <div class="div_8_divs_text">2021-03-29 08:28:37</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">静态ip资源的获得方式</div>
                    <div class="div_8_divs_text">2021-03-26 08:51:49</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="div_8_divs">
                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">HTTP代理IP后和原本有何区别？</div>
                    <div class="div_8_divs_text">2021-03-29 09:40:22</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">代理IP服务器的广泛用途</div>
                    <div class="div_8_divs_text">2021-03-29 09:31:34</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">爬虫代理IP能解决哪些问题</div>
                    <div class="div_8_divs_text">2021-03-29 08:48:59</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">http代理服务器是如何连接的？</div>
                    <div class="div_8_divs_text">2021-03-26 08:55:14</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>

                <div class="div_8_divs_div">
                  <div>
                    <div class="div_8_divs_H">IP代理的起源和作用</div>
                    <div class="div_8_divs_text">2021-03-26 08:33:22</div>
                  </div>
                  <div>
                    <div class="div_butt_bot">
                      点击查看<i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="security_main_body_E">
          <div class="security_main_body_E_div">
            <div class="security_main_body_E_div_div">
              <div>
                <div class="security_main_body_E_div_divA">
                  企业及大客户定制
                </div>
                <div class="security_main_body_E_div_divB">
                  根据您的业务需求量身定制解决方案
                </div>
              </div>
              <div class="dis_dis">
                <div>
                  <div class="security_main_body_E_div_divC">
                    <i class="el-icon-check"></i>更低价格
                  </div>
                  <div class="security_main_body_E_div_divC">
                    <i class="el-icon-check"></i>专属资源池
                  </div>
                  <div class="security_main_body_E_div_divC">
                    <i class="el-icon-check"></i>定制功能
                  </div>
                </div>
                <div>
                  <div class="security_main_body_E_div_divC">
                    <i class="el-icon-check"></i>更低价格
                  </div>
                  <div class="security_main_body_E_div_divC">
                    <i class="el-icon-check"></i>专属资源池
                  </div>
                  <div class="security_main_body_E_div_divC">
                    <i class="el-icon-check"></i>定制功能
                  </div>
                </div>
              </div>

              <div>
                <div class="lxkf">联系客服</div>
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import api from "@/requset/api";
export default {
  data() {
    return {
      guojianame: "",
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示的条目数
      totalData: 0, // 数据总条目数
      tableData: [], // 所有数据
    };
  },
  components: {
    Head,
    Footer,
  },
  computed: {
    // paginatedData() {
    //   const start = (this.currentPage - 1) * this.pageSize;
    //   return this.tableData.slice(start, start + this.pageSize);
    // },
  },
  created() {
    // 在组件创建时获取路由参数
    // this.userId = this.$route.params.id;
  },
  onload() {},
  mounted() {
    this.fetchData(); // 组件挂载后获取数据
  },

  methods: {
    openWeChatChat() {
    },
    handleCurrentChange(page) {
      this.currentPage = page; // 更新当前页
      this.fetchData()
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.tableData.slice(start, start + this.pageSize);
    },
    fetchData() {
      this.guojianame = this.$route.query.name;
      api
        .ip_list({
          offset: this.currentPage,
          limit: 10,
          nation: this.guojianame,
        })
        .then((res) => {
          console.log(res.data);
          this.tableData = res.data.data.GetIPList;
          // this.$message.success(res.message);
          this.totalData = res.data.data.Total; // 更新总数据条目数
        })
        .catch((err) => {
          console.log(err, "走失败");
        });
    },
  },
};
</script>
<style>
.el-icon-check {
  font-size: 18px;
  margin-top: 5px;
  margin-right: 5px;
}
.el-icon-right {
  font-size: 18px;
  margin-top: 2px;
  margin-left: 5px;
}
.area_index_main_div_div {
  display: flex;
  justify-content: center;
}
.area_index_main_divs {
  width: 1300px;
  display: flex;
  justify-content: space-around;
}
.area_index_main_divsB {
  width: 1300px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-top: 200px;
}
.area_index_main_divs_divA {
  width: 49%;
  height: 400px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
}
.area_index_main_divs_divA > div:nth-child(1) {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 38px;
  color: #1b2336;
  line-height: 53px;
  margin-bottom: 5px;
}
.area_index_main_divs_divA > div:nth-child(2) {
  font-family: SourceHanSansCN-Medium;
  font-size: 58px;
  color: #6c63ff;
  line-height: 81px;
  margin-bottom: 4px;
}
.div_text5 {
  font-weight: 400;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
}
/* .area_index_main_divs_divA > div:nth-child(4){
    display: flex;
    justify-content: center;
} */
.butt_divarea {
  padding: 0 50px;
  height: 54px;
  background: #6327d3;
  border-radius: 36px;
  text-align: center;
  line-height: 54px;
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #edf3fc;
  margin-top: 32px;
  width: max-content;
  display: block;
}
.butt_divB {
  margin-top: 84px;
  height: 55px;
  border-radius: 12px;
  padding: 0 33px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #6327d3;
  border: 1px solid #6327d3;
  width: max-content;
  line-height: 55px;
  cursor: pointer;
}
.area_index_main_divs_divB {
  width: 49%;
  height: 400px;
}

.area_index_main_divs_divB > img {
  width: 640px;
  height: 313px;
}
.area_index_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 40px;
  color: #1b2336;
  line-height: 44px;
  text-align: center;
  margin-bottom: 100px;
}
.area_index_name {
  text-align: center;
  margin-top: 17px;
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #071223;
  line-height: 17px;
}
.area_index_text {
  margin-top: 32px;
  font-weight: 400;
  font-size: 18px;
  color: #565656;
  line-height: 28px;
  text-align: center;
}
.area_index_body {
  display: flex;
  justify-content: center;
}
.div_area_index_bodyB {
  display: flex;
  justify-content: center;
}
.area_index_bodyB {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 1450px;
  text-align: center;
}
.area_index_body > div {
  width: 260px;
  margin: 50px;
}
.table_butt {
  width: 272px;
  height: 55px;
  background: linear-gradient(224deg, #6327d3, #41188d);
  border-radius: 8px;
  line-height: 55px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #edf3fc;
  text-align: center;
  display: block;
  margin: 53px auto 0;
  cursor: pointer;
}
.div_text6 {
  margin-top: 22px;
  font-weight: 400;
  font-size: 18px;
  color: #565656;
  line-height: 26px;
}
.area_index_main_divs_divD {
  margin-top: 200px;
}
.area_index_main_divs_divE {
  margin: 200px;
}
.DB {
  margin-top: 250px;
  width: 573px;
}
.with1500 {
  width: 1500px;
}
.top200 {
  margin-top: 200px;
}
.with1500 {
  margin: 0 auto;
}
.DBE {
  margin-top: 200px;
}
.div_5_div_H {
  font-family: SourceHanSansCN-Medium;
  font-size: 30px;
  color: #071223;
  margin-top: 33px;
  text-align: center;
  font-weight: 500;
}
.div_5_div_text {
  font-weight: 400;
  font-size: 18px;
  color: #565656;
  margin-top: 23px;
  text-align: center;
}
.div_5_div_butts {
  display: block;
  height: 48px;
  background: #f1f6ff;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #6327d3;
  line-height: 48px;
  text-align: center;
  margin-top: 37px;
  margin-bottom: 47px;
}
.div_4 {
  display: flex;
  justify-content: center;
}
.div_div_5 {
  display: flex;
  justify-content: space-between;
  width: 1400px;
}
.div_5_div_li {
  margin-bottom: 24px;
  font-weight: 400;
  font-size: 14px;
  color: #364050;
  line-height: 22px;
  display: flex;
  align-items: center;
}
.div_5 {
  width: 280px;
  padding: 20px;
  border-radius: 12px;
}
.div_5:hover {
  box-shadow: #6327d3 0px 1px 4px, #6327d3 0px 0px 0px 3px;
}
.div_5:hover .div_5_div_butts {
  display: block;
  height: 48px;
  background: #6327d3;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #f1f6ff;
  line-height: 48px;
  text-align: center;
  margin-top: 37px;
  margin-bottom: 47px;
}
.H2 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  margin-bottom: 100px;
}
.div_butt_bot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 48px;
  background: #f1f6ff;
  border-radius: 8px;
  font-family: SourceHanSansCN-Medium;
  font-size: 15px;
  color: #3f61d1;
}
.div_8_divs {
}
.div_div_8_divs {
  display: flex;
  justify-content: space-between;
  width: 1400px;
  margin: 0 auto;
}
.div_8_divs_div {
  display: flex;
  justify-content: space-between;
  width: 525px;
  padding: 30px;
  margin: 10px;
}
.div_8_divs_H {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 18px;
  color: #121d2f;
  line-height: 21px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  margin-bottom: 22px;
  text-align: left;
}
.div_8_divs_text {
  font-weight: 400;
  font-size: 14px;
  color: #121d2f;
  line-height: 14px;
  text-align: left;
}
.div_8 {
  margin-top: 120px;
}

.security_main_body_E_div {
  display: flex;
  justify-content: center;
}

.security_main_body_E_div_div {
  margin-top: 200px;
  width: 1297px;
  height: 348px;
  display: flex;
  justify-content: space-around;
  background-image: url(http://apiupss.ppfly.top/images/free_serve_bg_1.png);
}
.security_main_body_E_div_div > div {
  margin-top: 120px;
}
.security_main_body_E_div_div > div:nth-child(3) {
  margin-top: 80px;
}
.erwema {
  width: 195px;
  border-radius: 15px;
}

.security_main_body_E_div_divA {
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 32px;
  color: #edf3fc;
}

.security_main_body_E_div_divB {
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 18px;
  color: #edf3fc;
  margin-top: 27px;
}

.security_main_body_E_div_divC {
  width: 240px;
  display: flex;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #edf3fc;
  margin-bottom: 20px;
}
.dis_dis {
  display: flex;
  justify-content: center;
}
.lxkf {
  margin-top: 60px;
  margin-right: 20px;
  width: 215px;
  height: 64px;
  background: #edf3fc;
  border-radius: 8px;
  font-family: SourceHanSansCN-Medium;
  font-size: 19px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.div_8_divs_div:hover .div_butt_bot {
  background-color: #0c4ce1;
  color: #edf3fc;
}
</style>
